<template>
  <div class="flex items-start profile-role-hld">
    <div v-if="params.data.Location && params.data.Location.length > 1">
      Multiple
    </div>
    <div v-else-if="params.data.Location && params.data.Location.length == 1">
      {{params.data.Location[0].Name}}
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererLocations",
  methods: {


  },
  computed: {},
};
</script>
<style scoped>

</style>